exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "blockpassword{width:100%;height:100%}.footer-blockpassword{font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/app/components/views/blockpassword/blockpassword.style.scss
// module id = 802
// module chunks = 0